import { IconButton, Switch, Typography } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import { useDispatch } from 'src/hooks/useDispatch'
import { commentsDrawerClosed } from 'src/slices/appLayoutSlice'

type CommentsDrawerHeaderProps = {
  showResolved: boolean
  setShowResolved: React.Dispatch<React.SetStateAction<boolean>>
  showResolvedDisabled?: boolean
}

const CommentsDrawerHeader = ({
  showResolved,
  setShowResolved,
  showResolvedDisabled,
}: CommentsDrawerHeaderProps) => {
  const dispatch = useDispatch()
  return (
    <div className="flex justify-between px-2 pb-1">
      <Typography variant="h6" className="pt-2">
        Comments
      </Typography>
      <div className="flex flex-col items-end">
        <IconButton onClick={() => dispatch(commentsDrawerClosed())}>
          <CloseIcon />
        </IconButton>
        <div className="flex items-center justify-end">
          <Typography variant="caption" className="select-none">
            Show Resolved
          </Typography>
          <Switch
            onChange={(_, checked) => setShowResolved(checked)}
            checked={showResolved}
            disabled={showResolvedDisabled}
          />
        </div>
      </div>
    </div>
  )
}

export default CommentsDrawerHeader
